import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { showErrorPopup } from '../actions/notification-actions';

export const AuthErrorCodes = {
    AUTH_METHOD: 'auth_method_error',
    ACCT_ALREADY_LINKED: 'acct_already_linked',
};

export const ACCT_ALREADY_LINKED_MESSAGE = 'Account already linked to another UTR Sports account';

// OAuth failures come back on whatever page started the flow, so any page that can
// originate a social sign-in has to surface `?error` itself or it is swallowed silently.
export const useAuthErrorPopup = (error) => {
    const dispatch = useDispatch();
    const [showLinkedAccountExistsPopup, setShowLinkedAccountExistsPopup] = useState(false);

    useEffect(() => {
        if (!error) {
            return;
        }

        if (error === AuthErrorCodes.AUTH_METHOD) {
            setShowLinkedAccountExistsPopup(true);
        } else if (error === AuthErrorCodes.ACCT_ALREADY_LINKED) {
            dispatch(showErrorPopup({ message: ACCT_ALREADY_LINKED_MESSAGE, showSupportLink: true }));
        } else {
            dispatch(showErrorPopup({ showSupportLink: true }));
        }
    }, [error, dispatch]);

    const dismissLinkedAccountExistsPopup = useCallback(() => {
        setShowLinkedAccountExistsPopup(false);
    }, []);

    return {
        showLinkedAccountExistsPopup,
        dismissLinkedAccountExistsPopup,
    };
};
